import { getPublisherClassText } from '@intelligence/pages/TopCharts/PCConsoleGames/utils';
import { getHeaderIntelligence, getHeaderWidthIntelligence } from './utils';
import { LANGUAGE_CN } from '@home/_config/config';

import type { TableColumn } from 'tea-component';
import type { IColumnBaseOption, IColumnHeaderOption } from './utils';

interface IPublisherClassColumnBuilderOptionCore<T> {
  placeholder?: IPlaceholder;
  publisherClassKey?: string;
  formatMessage: (descriptor: { id: string }) => string;
  getPublisherClass?: (record: T) => string | undefined;
}

interface IPublisherClassColumnBuilderOption<T>
  extends Partial<TableColumn<T>>,
  IColumnBaseOption,
  IColumnHeaderOption,
  IPublisherClassColumnBuilderOptionCore<T> {}

const getDefaultPublisherClass = <T extends IRecord = IRecord>(record: T, publisherClassKey: string): string => {
  const value = record?.[publisherClassKey];
  if (typeof value === 'string') {
    return value;
  }

  return '';
};

const PublisherClassColumnBuilder = <T extends IRecord = IRecord>(
  option: IPublisherClassColumnBuilderOption<T>,
): TableColumn<T> => {
  const {
    placeholder = '-',
    publisherClassKey = 'publisher_class',
    key = 'publisher_class',
    headerTranslatable = true,
    headerTranslateKey = 'dbi_publisher_class',
    header = 'Publisher Class',
    locale = 'en-US',
    align = 'left',
    width = locale === LANGUAGE_CN ? 170 : 150,
    widthCN,
    fixed,
    formatMessage,
    getPublisherClass,
  } = option;

  const headerWidth = getHeaderWidthIntelligence(locale, { width, widthCN });
  const headerText = getHeaderIntelligence(locale, { headerTranslatable, headerTranslateKey, header });

  return {
    key,
    align,
    fixed,
    width: headerWidth,
    header: headerText,
    render: (record) => {
      const publisherClass = getPublisherClass?.(record) || getDefaultPublisherClass(record, publisherClassKey);
      if (!publisherClass) {
        return placeholder;
      }

      return getPublisherClassText(publisherClass, formatMessage);
    },
  };
};

export default PublisherClassColumnBuilder;
